import {
  useGetBulkSummation,
  useGetManagementBulkSummation,
} from "../../../hooks/queries/useBulkUploadsQueries";

export const useBulkSummation = (isSuperAdmin = false) => {
  const merchantQuery = useGetBulkSummation({ enabled: !isSuperAdmin });
  const managementQuery = useGetManagementBulkSummation({ enabled: isSuperAdmin });

  const { data, isLoading, isError, refetch } = isSuperAdmin ? managementQuery : merchantQuery;

  return {
    totalVolume: data?.totalVolume ?? null,
    pendingBatches: data?.pendingBatches ?? null,
    completedToDay: data?.completedToDay ?? null,
    failedUploads: data?.failedUploads ?? null,
    isLoading,
    isError,
    refetch,
  };
};
